<template>
  <div>
    <app-spinner v-if="!is_page_loaded" />
    <template v-else>
      <v-client-table
        :data="table_analytics.items"
        :columns="table_analytics.columns"
        :options="table_analytics.options"
        class="table-default table-default--maxw"
      >
        <template #h__hotel><div class="table-default__left">Hotel</div></template>
        <template #h__overdue><div class="table-default__left">Overdue</div></template>
        <template #h__upcoming><div class="table-default__left">Upcoming</div></template>
        <template #h__total><div class="table-default__left">Total</div></template>
        <template #hotel="{ row }">
          <div class="table-default__left">{{ row.hotel.name }}</div>
        </template>
        <template #overdue="{ row }">
          <div class="table-default__left">{{ row.overdue.toLocaleString() }}$</div>
        </template>
        <template #upcoming="{ row }">
          <div class="table-default__left">{{ row.upcoming.toLocaleString() }}$</div>
        </template>
        <template #total="{ row }">
          <div class="table-default__left">{{ row.total_unpaid.toLocaleString() }}$</div>
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getReservationsPaymentPlanHotelsAnalytics } from '@/http'

export default {
  name: 'ReservationPaymentRequestsAnalytics',
  data() {
    return {
      is_page_loaded: false,
      table_analytics: {
        items: [],
        columns: ['hotel', 'overdue', 'upcoming', 'total'],
        options: {
          headings: {
            hotel: 'Hotel',
            overdue: 'Overdue',
            upcoming: 'Upcoming',
            total: 'Total',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 100,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    this.fetchAnalyticsItems()
  },
  methods: {
    fetchAnalyticsItems() {
      getReservationsPaymentPlanHotelsAnalytics()
        .then(res => {
          this.table_analytics.items = res.data
          this.is_page_loaded = true
        })
    },
  }
}
</script>
